import IconComponent from "icons/IconComponent";

import ConfirmIcon from "./confirm.svg";

export default (ConfirmIcon as any) as IconComponent;
